import { Group as Container } from './styles'

export function SelectGroup({ children }) {
  return <Container>{children}</Container>
}
